import React, { useState } from 'react';
import { Badge, Button, Card, Col, Container, Row } from 'react-bootstrap';
import { FiCheck } from 'react-icons/fi';
import '../Styles/MainStyles/Pricing.css';

const Pricing = () => {
  const [isYearly, setIsYearly] = useState(false);

  return (
    <section id="pricing" className="py-5 bg-white">
      <Container>
        <div className="text-center mb-5">
          <h2 className="fw-bold text-primary">Pricing Plans</h2>
          <p className="lead text-muted mx-auto" style={{ maxWidth: '700px' }}>
            Flexible options designed for organizations of all sizes
          </p>
          
          {/* Billing Toggle */}
          <div className="d-flex justify-content-center align-items-center mt-4 mb-4">
            <div className="billing-toggle mx-3">
              <Button
                variant={isYearly ? "primary" : "outline-secondary"}
                className={`billing-btn ${isYearly ? 'active' : ''}`}
                onClick={() => setIsYearly(true)}
              >
                Yearly billing
                
              </Button>
              <Button
                variant={!isYearly ? "primary" : "outline-secondary"}
                className={`billing-btn ms-2 ${!isYearly ? 'active' : ''}`}
                onClick={() => setIsYearly(false)}
              >
                Monthly billing
              </Button>
            </div>
          </div>
        </div>
        
        <Row className="g-4 justify-content-center">
          {pricingPlans.map((plan, index) => (
            <Col lg={4} md={6} key={index}>
              <Card className={`h-100 border-0 shadow-sm pricing-card ${
                plan.popular ? 'popular' : ''
              }`}>
                {plan.popular && (
                  <div className="popular-badge">
                    <Badge bg="success" className="px-3 py-2 w-100 text-center">
                      MOST POPULAR
                    </Badge>
                  </div>
                )}
                <Card.Body className="p-4 text-center">
                  <h3 className="mb-3 fw-bold">{plan.name}</h3>
                  <div className="price mb-3">
                    {plan.name === 'Free Trial' ? (
                      <>
                        <span className="amount display-4 fw-bold">14 Days</span>
                        <span className="period text-muted"> free</span>
                      </>
                    ) : (
                      <>
                        <span className="currency">$</span>
                        <span className="amount display-4 fw-bold">
                          {isYearly ? plan.yearlyPrice : plan.monthlyPrice}
                        </span>
                        <span className="period text-muted">/user/month</span>
                      </>
                    )}
                  </div>
                  <p className="text-muted mb-4">
                    {isYearly ? plan.yearlyBilling : plan.monthlyBilling}
                  </p>
                  <p className="text-muted small mb-4">{plan.description}</p>
                  <ul className="list-unstyled mb-4 text-start">
                    {plan.features.map((feature, idx) => (
                      <li key={idx} className="mb-2 d-flex align-items-start">
                        <FiCheck className="me-2 mt-1 flex-shrink-0 text-success" />
                        <span>{feature}</span>
                      </li>
                    ))}
                  </ul>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
        
        <div className="text-center mt-5">
          <p className="text-muted">
            Need a custom solution? <a href="#contact" className="text-primary">Contact our sales team</a>
          </p>
        </div>
      </Container>
    </section>
  );
};

const pricingPlans = [
  {
    name: 'Free Trial',
    monthlyPrice: 'Free',
    yearlyPrice: 'Free',
    monthlyBilling: '',
    yearlyBilling: '',
    description: 'Full features, no restrictions. Free checklist setup from our team!',
    features: [
      'Free checklist setup',
      'All Enterprise features',
      'Full access, no commitment'
    ],
    buttonText: 'Start Free Trial'
  },
  {
    name: 'Starter',
    monthlyPrice: '12',
    yearlyPrice: '10',
    monthlyBilling: 'Monthly Billing',
    yearlyBilling: 'Annual Billing',
    description: 'Complete auditing & inspections starter kit for small teams',
    features: [
      'Offline + Online',
      '24/7 Support',
      'Instant Reports',
      'Action Plan'
    ],
    buttonText: 'Get Started'
  },
  {
    name: 'Enterprise',
    monthlyPrice: '35',
    yearlyPrice: '30',
    monthlyBilling: 'Monthly Billing',
    yearlyBilling: 'Annual Billing',
    description: 'The ultimate all-in-one solution, ideal for larger teams',
    features: [
      'All Starter Plan features',
      'Roles & Permissions',
      'Scheduling & Notifications',
      'Advanced Reporting',
      'Advanced Trends'
    ],
    buttonText: 'Choose Enterprise',
    popular: true
  }
];

export default Pricing;